// removed by extract-text-webpack-plugin
module.exports = {"commentLabel":"_30q2bLV0j52PNSRbsfbBiG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReturnTransferForm/styles.css
// module id = 3221
// module chunks = 0